// Alfabetos sem caracteres ambíguos (0/O, 1/l/I): a senha gerada costuma ser
// ditada ou copiada à mão para o usuário final.
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%&*?';

function randomIndex(max: number): number {
	const buffer = new Uint32Array(1);
	window.crypto.getRandomValues(buffer);
	return buffer[0] % max;
}

function pick(charset: string): string {
	return charset[randomIndex(charset.length)];
}

// Garante ao menos um caractere de cada classe e embaralha o resultado, senão as
// quatro primeiras posições seriam sempre previsíveis (maiúscula, minúscula...).
export function generateStrongPassword(length = 16): string {
	const all = UPPER + LOWER + DIGITS + SYMBOLS;
	const chars = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SYMBOLS)];
	while (chars.length < length) {
		chars.push(pick(all));
	}
	for (let i = chars.length - 1; i > 0; i--) {
		const j = randomIndex(i + 1);
		[chars[i], chars[j]] = [chars[j], chars[i]];
	}
	return chars.join('');
}
